/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_CommunityInputs */

const id_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunitas`)
};

const ms_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komuniti`)
};

const da_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fællesskab`)
};

const de_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community`)
};

const en_us2_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community`)
};

const es_es2_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunidad`)
};

const es_mx2_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunidad`)
};

const fil_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunidad`)
};

const fr_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communauté`)
};

const it_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community`)
};

const hu_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közösség`)
};

const nl_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community`)
};

const no_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fellesskap`)
};

const pl_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Społeczność`)
};

const pt_br2_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunidade`)
};

const pt_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunidade`)
};

const ro_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunitate`)
};

const fi_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteisö`)
};

const sv_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemenskap`)
};

const vi_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cộng đồng`)
};

const tr_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topluluk`)
};

const cs_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunita`)
};

const bg_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общност`)
};

const ru_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщество`)
};

const uk_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спільнота`)
};

const ar_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المجتمع`)
};

const hi_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समुदाय`)
};

const th_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชุมชน`)
};

const ja_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミュニティ`)
};

const zh_cn2_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社区`)
};

const zh_hant1_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社群`)
};

const ko_footer_community = /** @type {(inputs: Footer_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커뮤니티`)
};

/**
* | output |
* | --- |
* | "Community" |
*
* @param {Footer_CommunityInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const footer_community = /** @type {((inputs?: Footer_CommunityInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_CommunityInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_footer_community(inputs)
	if (locale === "ms") return ms_footer_community(inputs)
	if (locale === "da") return da_footer_community(inputs)
	if (locale === "de") return de_footer_community(inputs)
	if (locale === "en-US") return en_us2_footer_community(inputs)
	if (locale === "es-ES") return es_es2_footer_community(inputs)
	if (locale === "es-MX") return es_mx2_footer_community(inputs)
	if (locale === "fil") return fil_footer_community(inputs)
	if (locale === "fr") return fr_footer_community(inputs)
	if (locale === "it") return it_footer_community(inputs)
	if (locale === "hu") return hu_footer_community(inputs)
	if (locale === "nl") return nl_footer_community(inputs)
	if (locale === "no") return no_footer_community(inputs)
	if (locale === "pl") return pl_footer_community(inputs)
	if (locale === "pt-BR") return pt_br2_footer_community(inputs)
	if (locale === "pt") return pt_footer_community(inputs)
	if (locale === "ro") return ro_footer_community(inputs)
	if (locale === "fi") return fi_footer_community(inputs)
	if (locale === "sv") return sv_footer_community(inputs)
	if (locale === "vi") return vi_footer_community(inputs)
	if (locale === "tr") return tr_footer_community(inputs)
	if (locale === "cs") return cs_footer_community(inputs)
	if (locale === "bg") return bg_footer_community(inputs)
	if (locale === "ru") return ru_footer_community(inputs)
	if (locale === "uk") return uk_footer_community(inputs)
	if (locale === "ar") return ar_footer_community(inputs)
	if (locale === "hi") return hi_footer_community(inputs)
	if (locale === "th") return th_footer_community(inputs)
	if (locale === "ja") return ja_footer_community(inputs)
	if (locale === "zh-CN") return zh_cn2_footer_community(inputs)
	if (locale === "zh-Hant") return zh_hant1_footer_community(inputs)
	return ko_footer_community(inputs)
});
export { footer_community as "footer.community" }